<nz-modal
  [nzStyle]="{width: '250px'}"
  [nzVisible]="true"
  nzTitle="Войдите в систему"
  [nzClosable]="false"
  [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <div class="button">
      <button nz-button nzType="primary" nzShape="round" (click)="login()">
        Keycloak
        <span nz-icon nzType="right"></span>
      </button>
    </div>
  </ng-container>
</nz-modal>